import React, { useEffect } from 'react';
import logoSrc from '../assets/logo.svg';

interface Props {
  onDone: () => void;
}

const SplashScreen: React.FC<Props> = ({ onDone }) => {
  useEffect(() => {
    const htmlSplash = document.getElementById('html-splash');
    if (htmlSplash) {
      htmlSplash.style.opacity = '0';
      setTimeout(() => htmlSplash.remove(), 260);
    }
    const t = setTimeout(onDone, 2600);
    return () => clearTimeout(t);
  }, [onDone]);

  return (
    <div style={{
      position: 'fixed', inset: 0, background: '#3b1f52',
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      zIndex: 9999,
    }}>
      <div style={{ animation: 'logoReveal 0.65s cubic-bezier(0.22,1,0.36,1) both' }}>
        <img src={logoSrc} alt="VAV School" style={{ width: 170, height: 170, objectFit: 'contain' }} />
      </div>

      <div style={{
        marginTop: 28, textAlign: 'center',
        animation: 'fadeIn 0.5s ease 0.5s both',
      }}>
        <div style={{ color: 'rgba(255,255,255,0.5)', fontSize: 12, letterSpacing: '3px', fontWeight: 600 }}>
       ATTENDANCE
        </div>
      </div>

      <div style={{
        position: 'absolute', bottom: 56,
        display: 'flex', gap: 8,
        animation: 'fadeIn 0.5s ease 1.1s both',
      }}>
        {[0, 1, 2].map(i => (
          <div key={i} style={{
            width: 7, height: 7, borderRadius: '50%',
            background: 'rgba(255,255,255,0.45)',
            animation: `pulse 1.4s ease ${i * 0.22}s infinite`,
          }} />
        ))}
      </div>

      <div style={{
        position: 'absolute', bottom: 28,
        fontSize: 10, color: 'rgba(255,255,255,0.28)', fontWeight: 500, letterSpacing: '1px',
        animation: 'fadeIn 0.5s ease 1.5s both',
      }}>
        Managed by VNEW Trust
      </div>
    </div>
  );
};

export default SplashScreen;
